import request from 'src/services/request';

export const getThemes = config => request.get('/preferences_themes', config);
export const getPreferences = () => request.get('/users/me/preferences');
export const getWorkPlaces = () => request.get('/preferences_countries');
export const getLanguages = () => request.get('/languages_list');
